module.exports = __webpack_public_path__ + "static/img/top-banner-img.e270cbb9.jpg";